import React from 'react';
import { NavLink } from 'react-router-dom';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { getRowUnits } from 'utils/util';
import Loading from 'components/_common/Loading';

const TripFeeListV = ({
    params,
    setParams,
    setSearch,
    pageChanged,
    handleChange,
    onChangeRowUnit,
    onSearch
}) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <span>출장비 관리</span>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header p-0 mt_20">
                            <div className="card-header-left"></div>
                            <div className="card-header-right">
                                <NavLink to="add">
                                    <button className="btn btn-primary" type="button">
                                        등록
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                        <div className="card-header p-0 mt_20">
                            <div className="row justify-content-between gap-3">
                                <div className="col-auto">
                                    <div className="g_table_sort">
                                        <span className="g_select">
                                            <select className="form-control" onChange={onChangeRowUnit} value={params.search.rows}>
                                                {getRowUnits().map((item, index) => (
                                                    <option key={index} value={item}>
                                                        {item}
                                                    </option>
                                                ))}
                                            </select>
                                        </span>
                                        / {params?.total?.toLocaleString()} rows
                                    </div>
                                </div>
                                <div className="col-auto list-filter">
                                    <div className="row gap-2">
                                        <div className="col-auto">
                                            <select
                                                className="form-control"
                                                value={params.search.type || ''}
                                                onChange={(e) => handleChange(e, 'search.type', setParams, params)}
                                            >
                                                <option value="">전체</option>
                                                <option value="province">도</option>
                                                <option value="city">지역</option>
                                            </select>
                                        </div>
                                        <div className="col-auto">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="이름 검색"
                                                value={params.search.name || ''}
                                                onChange={(e) => handleChange(e, 'search.name', setParams, params)}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="최소 금액"
                                                value={params.search.minAmount || ''}
                                                onChange={(e) => handleChange(e, 'search.minAmount', setParams, params)}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="최대 금액"
                                                value={params.search.maxAmount || ''}
                                                onChange={(e) => handleChange(e, 'search.maxAmount', setParams, params)}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="이름/메모 검색"
                                                    value={params.search.keyword || ''}
                                                    onChange={(e) => handleChange(e, 'search.keyword', setParams, params)}
                                                    onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" onClick={onSearch}>
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <table className="table text-nowrap">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th className="tal">타입</th>
                                        <th className="tal">이름</th>
                                        <th className="tar">출장비<br />(고객 청구)</th>
                                        <th className="tar">출장 비용<br />(출장자 지불)</th>
                                        <th className="tal" style={{ width: '30%' }}>메모</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {params.isLoaded && params.error == null && (
                                        <>
                                            {params.items.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{params.search.rows * params.search.page - (params.search.rows - (index + 1))}</td>
                                                    <td className="tal">
                                                        {item.type === 'province' ? (
                                                            <span className="badge badge-primary">도</span>
                                                        ) : (
                                                            <span className="badge badge-info">지역</span>
                                                        )}
                                                    </td>
                                                    <td className="tal">
                                                        <NavLink to={'update/' + item.id}>{item.name}</NavLink>
                                                    </td>
                                                    <td className="tar">
                                                        {item.type === 'province' && item.tripFee
                                                            ? `${item.tripFee.toLocaleString()}원`
                                                            : '-'}
                                                    </td>
                                                    <td className="tar">
                                                        {item.type === 'city' && item.tripCost
                                                            ? `${item.tripCost.toLocaleString()}원`
                                                            : '-'}
                                                    </td>
                                                    <td className="tal">{item.note || '-'}</td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <PaginationControl
                            page={params.search.page}
                            total={params.total}
                            limit={params.search.rows}
                            changePage={(page) => {
                                pageChanged(page, params.search, setParams, setSearch);
                                console.log(page);
                            }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default TripFeeListV;